import {Component, OnInit} from '@angular/core';
import {Router, RouterLink, RouterOutlet} from "@angular/router";
import {NgClass, NgOptimizedImage} from "@angular/common";
import { HorarioNavBarComponent} from "../app-persona/nav-bar/horario-nav-bar/horario-nav-bar.component";

@Component({
  selector: 'app-top-bar',
  standalone: true,
  imports: [
    HorarioNavBarComponent,
    RouterLink,
    NgClass,
    RouterOutlet,
    NgOptimizedImage
  ],
  templateUrl: './top-bar.component.html',
  styleUrl: './top-bar.component.css'
})
export class TopBarComponent implements OnInit{
  activeLink: string = 'personas';
  isEmpresaRoute: boolean = false;
  isPersonaOrRoute: boolean = false;
  currentLink : string | undefined;
  constructor(private router: Router) {
  }


  ngOnInit() {
    this.currentLink = this.router.url;

    this.router.events.subscribe((val) => {
      this.currentLink = this.router.url;
      this.updateRouteState()
    });


    // console.log(this.currentLink);

  }


  updateRouteState() {
    if (this.currentLink) {
      if (this.currentLink.startsWith('/empresa')) {
        this.isEmpresaRoute = true;
        this.isPersonaOrRoute = false;
      }else if (!this.currentLink.startsWith('/empresa') && !this.isPersonaOrRoute) {
        this.isPersonaOrRoute = true;
        this.isEmpresaRoute = false;
      }
    }
  }

  setActiveLink(link: string) {
    this.activeLink = link;
  }

  isCurrentRoute(route: string): boolean {
    return this.currentLink === route;
  }


}
